<template>
  <div>
    <v-row>
      <v-col cols="12" sm="8" md="6">
        <v-select
          v-model="hashtag"
          :items="hashtags"
          item-text="hashtag"
          item-value="id"
          label="#Hashtag"
          clearable
        />
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-btn
          color="primary"
          block
          :loading="loading"
          @click="search()"
        >
          Buscar
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="posts.length > 0">
      <v-col
        v-for="item in posts"
        :key="item.id"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <v-card>
          <v-img :src="item.thumb"></v-img>
          <v-card-actions>
            <v-spacer />
            <v-btn color="error" @click="removePost(item.id)">
              <v-icon left>fas fa-trash</v-icon>
              Eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-alert v-else type="info" text>
      No hay publicaciones para mostrar
    </v-alert>
    <v-pagination v-model="page" :length="pages"></v-pagination>
  </div>
</template>

<script>
export default {
  data () {
    return {
      hashtags: [],
      hashtag: null,
      posts: [],
      page: 1,
      pages: 1,
      loading: false
    }
  },
  created () {
    this.getHashtags()
  },
  methods: {
    async search () {
      this.page = 1
      this.pages = 1
      await this.getPages()
      await this.getPosts()
    },
    async getHashtags () {
      const { data } = await this.$http.hashtags.get('')
      this.hashtags = data
    },
    async getPages () {
      let url = '/count'
      if (this.hashtag) {
        url += `?hashtag=${this.hashtag}`
      }
      const { data } = await this.$http.igposts.get(url)
      this.pages = Math.ceil(data / 25)
    },
    async getPosts () {
      this.loading = true
      const skip = (this.page - 1) * 25
      let url = `?_limit=25&_start=${skip}&_sort=createdAt:DESC`
      if (this.hashtag) {
        url += `&hashtag=${this.hashtag}`
      }
      const { data } = await this.$http.igposts.get(url)
      this.posts = data
      this.loading = false
    },
    async removePost (id) {
      if (window.confirm('¿Estas seguro de eliminar el registro?')) {
        await this.$http.igposts.delete(`/${id}`)
        this.getPosts()
      }
    }
  },
  watch: {
    page () {
      this.getPosts()
    }
  }
}
</script>
